import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import AuthentigateStore from './AuthentigateStore'
import getters from './getters'
import { getInitialState } from './initialState'
import mutations from './mutations'

const loadRouter = () => import('@/router')

Vue.use(Vuex)

export const createStore = () => {
  const store = new AuthentigateStore({
    actions,
    mutations,
    getters,
    state: getInitialState()
  })

  window.store = store

  store.subscribe(async (mutation, _state) => {
    // redirect if user or account inactive
    if (mutation.type === 'set_account' || mutation.type === 'set_appUser') {
      // TODO ALPHA BUG inactivateaccount url appears on normal signout
      if (!mutation.payload.active) {
        const router = (await loadRouter()).default
        router.replace('/inactiveaccount')
      }
    }
  })

  return store
}
